<template>
  <div class="modal" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card animated zoomIn faster">
      <section class="modal-card-body">
        <div class="result">
          <div>ยินดีด้วย! คุณได้รับคูปอง</div>
          <div class="prize">{{ prize }}</div>

          <button
            class="confirm button is-light width-50"
            aria-label="close"
            @click="closeModal"
          >
            ยืนยัน
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalPrize',
  components: {},
  props: {
    prize: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  mounted() {},
  computed: {},
  methods: {
    closeModal() {
      this.$emit('closeModal', null)
    }
  }
}
</script>

<style scoped lang="scss">
.result {
  color: black;
  margin-top: 10px;
  text-align: center;

  .prize {
    font-size: 18px;
    font-weight: 600;
  }
}

.modal-card-body {
  border-radius: 20px;
  width: 80%;
  margin: auto;
}

.confirm {
  margin-top: 10px;
}
</style>
